"use client";

import { PropsWithChildren, useEffect } from "react";

import { ViewSeo } from "@ctv/shared-core/src";

import { useAuth } from "@ctv/core/auth/CognitoAuthContext";

import { useFeatureControl } from "../feature-control/FeatureControlContext";
import { FC_MWEB } from "../feature-control/constants";
import styles from "./Wrapper.module.css";

// (michael-harley) TODO: Will need to adjust this when we implement mobile web for PostLogin pages
// Fix: https://29022131.atlassian.net/browse/CTVOPS-251
export default function Wrapper(props: PropsWithChildren<unknown>) {
  const { children } = props;

  const { isAuthenticated } = useAuth();
  const { enabled } = useFeatureControl(FC_MWEB);

  useEffect(() => {
    /**
     * @description
     * screen wrapper min width 1240px
     */
    if (!enabled && isAuthenticated) {
      document.body.classList.add(styles.authenticated);
    }
    return () => {
      document.body.classList.remove(styles.authenticated);
    };
  }, [enabled, isAuthenticated]);

  return (
    <ViewSeo id="screenWrapper" className={`${styles.wrapper}`}>
      {children}
    </ViewSeo>
  );
}
